// Manrope carries the UI: a semi-geometric sans with tall x-height and tight
// spacing, so timesheet rows and money columns stay dense without crowding.
// It also stops MintStint reading as Florafolio's twin — the two shared DM Sans.
// DM Mono stays for figures (durations, rates, invoice totals).
export const fonts = {
  regular: "Manrope_400Regular",
  medium: "Manrope_500Medium",
  semibold: "Manrope_600SemiBold",
  bold: "Manrope_700Bold",
  mono: "DMMono_400Regular",
  monoBold: "DMMono_500Medium",
} as const;

export const fontSizes = {
  xs: 12,
  sm: 14,
  base: 16,
  lg: 18,
  xl: 24,
  xxl: 32,
} as const;

// Named roles on the shared modular scale (mirrors the website type scale).
// Use these instead of ad-hoc numbers for page and section headers.
export const textRoles = {
  pageTitle: 28,
  pageSubtitle: 14,
  sectionTitle: 17,
  eyebrow: 12,
} as const;

export const letterSpacing = {
  eyebrow: 0.8,
  tight: -0.2,
} as const;

export const lineHeights = {
  tight: 1.2,
  normal: 1.5,
  relaxed: 1.65,
} as const;
